<template>
  <ul class="ace-steps">
    <li
      v-for="(step, index) in steps"
      :class="{ 'ace-steps__step--selected': index + 1 === currentStep }"
      class="ace-steps__step"
      :key="index"
    >
      <span class="ace-steps__step-number-wrap">
        <span class="ace-steps__step-number">
          {{ index + 1 }}
        </span>
      </span>
      <span class="ace-steps__step-name">{{ step }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['steps', 'currentStep'],
};
</script>

<style scoped lang="scss">
.ace-steps {
  margin: 0;
  padding: 0;

  display: flex;

  list-style-type: none;

  position: relative;

  column-gap: 15px;
  @media screen and (min-width: 767px) {
    column-gap: 150px;
  }
  &:before {
    content: '';

    border-top: 1px solid #707070;

    width: 100%;

    display: block;

    position: absolute;
    top: 12.5px;
    z-index: -1;
  }
  &__step {
    $this: &;

    background: #ffffff;

    display: flex;
    flex-direction: column;

    position: relative;

    align-items: center;
    @media screen and (min-width: 767px) {
      width: 130px;
    }
    &:before,
    &:after {
      content: '';
      transform: translateY(-50%);

      background: #4f324c;
      border-radius: 50%;

      height: 4px;
      width: 4px;

      position: absolute;
      top: 13px;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
    &:first-child {
      &:before {
        content: none;
      }
    }
    &:last-child {
      &:after {
        content: none;
      }
    }
    &-number {
      background: none;
      border: 1px solid #4f324c;
      border-radius: 50%;

      height: 25px;
      width: 25px;

      display: flex;

      font-size: 18px;
      font-weight: bold;

      justify-content: center;
      align-items: center;
    }
    &-name {
      margin-top: 5px;

      font-size: 15px;
      font-weight: bold;
    }
    &--selected {
      #{$this}-number {
        background: #00a84e;
        border: 1px solid #00a84e;
        color: #ffffff;
      }
      #{$this}-name {
        font-weight: bold;
      }
    }
  }
}
</style>
